import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'wl-review-stars',
  templateUrl: './review-stars.component.html',
  styleUrls: [
    './review-stars.component.essent.scss',
    './review-stars.component.ed.scss',
  ],
})
export class ReviewStarsComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public maxStars = 5;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public maxScore = 10;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public score = 10;

  public emptyStars: IconProp[] = [];

  public fullStars: IconProp[] = [];

  public showHalfStar = false;

  public ngOnInit() {
    this.initializeStarIcons();
  }

  private initializeStarIcons(): void {
    const numberOfStars = this.calculateNumberOfStars();
    this.emptyStars = this.initializeEmptyStars();
    this.fullStars = this.initializeFullStars(numberOfStars);
    this.showHalfStar = this.hasHalfStar(numberOfStars);
  }

  private calculateNumberOfStars(): number {
    return this.roundToNearestHalf(
      (this.score * this.maxStars) / this.maxScore
    );
  }

  private initializeEmptyStars(): IconProp[] {
    return new Array(this.maxStars).fill(['fas', 'star']);
  }

  private initializeFullStars(numberOfStars: number): IconProp[] {
    return new Array(Math.floor(numberOfStars)).fill(['fas', 'star']);
  }

  private hasHalfStar(numberOfStars: number) {
    return numberOfStars % 1 === 0.5;
  }

  private roundToNearestHalf(num: number): number {
    return Math.round(num * 2) / 2;
  }
}
